<div class="communities-page">
  <section class="hero-section">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-8">
          <div class="hero-content">
            <div class="eyebrow mb-2">Communities we support</div>
            <h1 class="headline mt-primary-text mb-2">Built for professional communities that need structure to grow</h1>
            <p class="subheadline mt-primary-text mb-4">
              Medical societies, surgical associations, physician entrepreneur networks, and more: memberships, events, directories, and chapter growth in one platform—web, shared <a routerLink="/mobile" class="inline-link">MemberTrace app</a>, and optional fully branded apps for Enterprise.
            </p>
            <div class="cta-buttons mb-4">
              <button mat-flat-button color="primary" (click)="scrollToExplore()">Explore communities</button>
              <button mat-stroked-button color="primary" routerLink="/start-a-community">Start a community</button>
            </div>
            <div class="hero-visual-strip">
              <img src="/img/communities-hero.webp" alt="MemberTrace for professional communities" onerror="this.style.display='none'; this.nextElementSibling?.classList.add('show');" />
              <div class="hero-visual-placeholder" aria-hidden="true"></div>
            </div>
            <p class="proof-line">Trusted by specialty societies and professional membership communities</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="explore-communities" class="communities-grid">
    <div class="container">
      <div class="row bridge-row">
        <div class="col-12 text-center">
          <h2 class="bridge-line">Choose your community type</h2>
          <p class="bridge-support">Explore how MemberTrace supports organizations like yours.</p>
        </div>
      </div>
      <div class="row g-4 cards-row">
        <div class="col-lg-6" *ngFor="let community of communities">
          <mat-card class="community-card h-100" [routerLink]="community.route">
            <div class="community-card-banner" [class.banner-medical]="community.bannerStyle === 'medical'" [class.banner-entrepreneur]="community.bannerStyle === 'entrepreneur'" [style.backgroundImage]="community.imageUrl ? 'url(' + community.imageUrl + ')' : null"></div>
            <mat-card-content class="p-4">
              <div class="card-icon mb-3">
                <mat-icon color="primary" class="icon-large">{{ community.icon }}</mat-icon>
              </div>
              <h3 class="card-title mb-2">{{ community.title }}</h3>
              <p class="card-description mb-4">{{ community.description }}</p>
              <p class="examples-label mb-2">{{ community.examplesLabel }}</p>
              <ul class="examples-list">
                <li *ngFor="let ex of community.examples">{{ ex }}</li>
              </ul>
              <span class="card-link">{{ community.ctaText }} <mat-icon class="arrow">arrow_forward</mat-icon></span>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-8 mx-auto">
          <mat-card class="community-card community-card-bridge h-100" routerLink="/start-a-community">
            <mat-card-content class="p-4">
              <span class="bridge-label">For new communities</span>
              <div class="card-icon mb-3">
                <mat-icon color="accent" class="icon-large">add_circle</mat-icon>
              </div>
              <h3 class="card-title mb-2">Build your own community</h3>
              <p class="card-description mb-4">Starting a professional network, membership group, or local chapter that doesn't fit neatly into a category yet? MemberTrace gives you the structure to launch and grow from day one.</p>
              <span class="card-link">Start a community <mat-icon class="arrow">arrow_forward</mat-icon></span>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </section>

  <section class="manage-section py-5">
    <div class="container">
      <div class="row mb-4">
        <div class="col-12 text-center">
          <h2 class="manage-section-title">Everything your community needs to operate and grow</h2>
        </div>
      </div>
      <div class="row mb-4 manage-screenshot-row" *ngIf="productScreenshotUrl">
        <div class="col-12">
          <div class="manage-screenshot-wrap">
            <img [src]="productScreenshotUrl" alt="MemberTrace platform overview" />
          </div>
        </div>
      </div>
      <div class="row g-4">
        <div class="col-md-6 col-lg-4" *ngFor="let item of manageItems">
          <div class="manage-item">
            <mat-icon color="primary" class="manage-icon">{{ item.icon }}</mat-icon>
            <span class="manage-label">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="trust-section py-5">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="trust-title">Trusted by professional membership communities</h2>
          <app-client-logo-strip variant="marquee" />
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <h2 class="cta-title mb-3">Find the right setup for your community</h2>
          <p class="cta-subtitle mb-4">Whether you're running an established society or launching a new physician-led network, MemberTrace gives you the structure to grow.</p>
          <div class="cta-visual" *ngIf="ctaVisualUrl">
            <img [src]="ctaVisualUrl" alt="" aria-hidden="true" />
          </div>
          <div class="cta-buttons d-flex flex-wrap gap-3 justify-content-center">
            <button mat-flat-button color="primary" (click)="scrollToExplore()">Explore communities</button>
            <button mat-stroked-button color="primary" routerLink="/start-a-community">Start a community</button>
            <button mat-stroked-button color="primary" routerLink="/contact">Talk to our team</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
